import { createMeasurement, type MeasurementProps } from './createMeasurement';

export type EnergyProps = MeasurementProps<'energy'>;

/**
 * An amount of energy, in kilowatt hours.
 *
 * One unit worldwide, so nothing converts. It is a component all the same, so that a charging
 * figure is written the same way as every other quantity beside it and picks up the same rounding
 * and empty-value rules.
 */
const Energy = createMeasurement('energy', 'Energy');

export default Energy;
